export enum LogLevel {
  OFF = 0,
  INFO = 1,
  SUCCESS = 2,
  ERROR = 3,
  WARN = 4,
  DEBUG = 5,
  TRACE = 6,
}
